import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatDate } from "../../../helpers/DateConversion";

export default function DeletedDriversTable() {
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [goToPage, setGoToPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);

    const { pageNo } = useParams();
    const navigate = useNavigate(null);

    useEffect(() => {
        setCurrentPage(parseInt(pageNo) || 1);
        setGoToPage(parseInt(pageNo) || 1);
        getDeletedDrivers();
    }, []);

    useEffect(() => {
        getDeletedDrivers();
    }, [currentPage, searchTerm, recordsPerPage]);

    const handlePrevious = () => {
        navigate(`/admin-panel/driver/deleted/${currentPage - 1}`);
        setCurrentPage(currentPage - 1);
        setGoToPage(currentPage - 1);
    };

    const handleNext = () => {
        navigate(`/admin-panel/driver/deleted/${currentPage + 1}`);
        setCurrentPage(currentPage + 1);
        setGoToPage(currentPage + 1);
    };

    const handleGoToPage = (page) => {
        if (!page) {
            navigate(`/admin-panel/driver/deleted/${goToPage}`);
        } else {
            navigate(`/admin-panel/driver/deleted/${page}`);
            setCurrentPage(page);
        }
        setGoToPage(page);
    };

    // Fetching Data
    const getDeletedDrivers = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("sansadToken");
            const headers = {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };
            if (currentPage < 1) {
                setCurrentPage(1);
                setGoToPage(1);
                setSearchTerm("");
                toast.error("Page number should be greater than or equal to 1");
                return;
            }
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/admin/view-deleted-drivers?page=${currentPage}&search=${searchTerm}&limit=${recordsPerPage}`,
                {
                    headers: headers,
                }
            );
            if (response.data.statusCode === 200) {
                setData(response.data.result.users);
                setTotalRecords(response.data.result.totalUsers);
                setCurrentPage(response.data.result.currentPage);
                setTotalPages(response.data.result.totalPages);
            } else {
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };

    return (
        <div>
            <ToastContainer />
            <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
                <div className="flex md:flex-row flex-col justify-between md:items-center items-start">
                    <h2 className="md:text-xl text-lg font-medium">Deleted Drivers</h2>
                    <div className="flex justify-center gap-4 md:mt-0 mt-4">
                        <input
                            type="text"
                            placeholder="Search Name, Email, Phone"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="border border-gray-400 rounded-md px-3 h-[32px] text-sm"
                        />

                        <div className="md:flex flex-col relative -top-1 hidden">
                            <span className="text-xs mb-0.5">Per Page</span>
                            <select
                                name="perPage"
                                id="perPage"
                                className="border border-[grey] rounded-md h-[22px] text-sm !outline-none"
                                value={recordsPerPage}
                                onChange={(e) => setRecordsPerPage(e.target.value)}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                            </select>
                        </div>
                        <div className="md:flex flex-col relative -top-1 hidden">
                            <span className="text-xs mb-0.5">Go to</span>
                            <input
                                type="number"
                                className="border border-[grey] rounded-md w-[50px] text-xs h-[22px] px-1 !outline-none"
                                value={goToPage}
                                onChange={(e) => {
                                    handleGoToPage(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 justify-between flex-wrap mt-10 md:text-base text-sm">
                    <table className="w-full text-center">
                        <thead>
                            <tr className="border-b">
                                <td className="font-medium py-4 cursor-pointer">S.No</td>
                                <td className="font-medium py-4 cursor-pointer">Name</td>
                                <td className="font-medium py-4 cursor-pointer">Email</td>
                                <td className="font-medium py-4 cursor-pointer">Phone</td>
                                <td className="font-medium py-4 cursor-pointer">Delete Reason</td>
                                <td className="font-medium py-4 cursor-pointer">Deleted At</td>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ? (
                                data?.length > 0 ? (
                                    data?.map((item, index) => (
                                        <tr key={item._id} className="border-b">
                                            <td className="py-3 text-sm">{index + 1}</td>
                                            <td className="py-3 text-sm">{item.name}</td>
                                            <td className="py-3 text-sm">{item.email}</td>
                                            <td className="py-3 text-sm">{item.phone}</td>
                                            <td className="py-3 text-sm">{item.deleteReason || "-"}</td>
                                            <td className="py-3 text-sm">{formatDate(item.deletedAt)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <td colSpan={6} className="text-center">
                                        <p className="text-center w-full mt-10">No results found</p>
                                    </td>
                                )
                            ) : (
                                <td colSpan={6} className="text-center">
                                    <p className="text-center w-full mt-10">Loading ...</p>
                                </td>
                            )}
                        </tbody>
                    </table>
                    <div className="flex justify-between items-center w-full mt-6">
                        <div className="">
                            <span className="text-[13px] text-gray-500">
                                Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                                {currentPage * recordsPerPage > totalRecords
                                    ? totalRecords
                                    : currentPage * recordsPerPage}{" "}
                                out of {totalRecords}
                            </span>
                        </div>
                        <div className="flex justify-center items-center gap-x-3">
                            <button
                                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                                disabled={currentPage === 1}
                                onClick={handlePrevious}
                            >
                                <i className="fa fa-chevron-left"></i>
                            </button>
                            <span className="text-[13px] text-gray-500">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                                disabled={currentPage === totalPages}
                                onClick={handleNext}
                            >
                                <i className="fa fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
